import { createSlice } from "@reduxjs/toolkit";

const volunteerPopupSlice = createSlice({
  name: "volunteerPopup",
  initialState: {
    isOpen: false,
  },
  reducers: {
    openVolunteerPopup: (state) => {
      state.isOpen = true;
    },
    closeVolunteerPopup: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openVolunteerPopup, closeVolunteerPopup } =
  volunteerPopupSlice.actions;

export default volunteerPopupSlice.reducer;
